// One write on a shape step: a 422 goes to the row / list that owns it (the
// server's own sentence), anything else is the shell's error card whose
// «أعد المحاولة» repeats that same write.

import { useRef, useState } from 'react';
import { isApiError, type ApiError } from '@/lib/api';
import type { WizardError } from '../../components/Wizard';
import { failureOf } from '../../data/api';

export function firstMessage(e: ApiError): string {
  return e.errors?.find((r) => r.message)?.message ?? e.detail ?? e.message;
}

export function useShapeAction() {
  const [failure, setFailure] = useState<Pick<WizardError, 'kind' | 'ref' | 'detail'> | null>(null);
  const [busy, setBusy] = useState(false);
  const last = useRef<(() => Promise<void>) | null>(null);

  const act = async (fn: () => Promise<void>, on422?: (e: ApiError) => void): Promise<boolean> => {
    last.current = async () => {
      await act(fn, on422);
    };
    setBusy(true);
    setFailure(null);
    try {
      await fn();
      return true;
    } catch (e) {
      if (on422 && isApiError(e) && e.status === 422) on422(e);
      else setFailure(failureOf(e));
      return false;
    } finally {
      setBusy(false);
    }
  };

  const error: WizardError | null = failure ? { ...failure, onRetry: () => void last.current?.() } : null;
  return { act, busy, error };
}
